import dayjs from "dayjs";
import { getUpcomingAppointments } from "../utils/reshapData";
import { useAppointments } from "./useAppointments";
import { getDateTimeDate } from "../utils/timeHelpers";
import { useMemo } from "react";

export const useUpcomingMeetings = (slug) => {
  const { data: myAppointments } = useAppointments();

  const upcomingMeetingsByDate = useMemo(() => {
    const appointmentByDate = myAppointments
      ? getUpcomingAppointments(
          [...myAppointments].filter((item) => {
            return (
              item.item_type === "cohort" &&
              item.slug === slug &&
              dayjs(getDateTimeDate(item.start_date)).isSame(
                dayjs().format("YYYY-MM-DD")
              )
            );
          })
        )
      : [];
    return appointmentByDate;
  }, [myAppointments, slug]);

  const allUpcomingMeetingsByDate = useMemo(() => {
    const appointmentByDate = myAppointments
      ? getUpcomingAppointments(
          [...myAppointments].filter((item) => {
            return (
              item.item_type === "cohort" &&
              item.slug === slug &&
              (dayjs(getDateTimeDate(item.end_date)).isAfter(
                dayjs().format("YYYY-MM-DD")
              ) ||
                dayjs(getDateTimeDate(item.end_date)).isSame(
                  dayjs().format("YYYY-MM-DD")
                ))
            );
          })
        )
      : [];
    return appointmentByDate;
  }, [myAppointments, slug]);

  return { upcomingMeetingsByDate, allUpcomingMeetingsByDate };
};
